export const getUserPhotoUrl = (
  user?: { email: string; name: string; photoUrl: string } | null
) =>
  user?.photoUrl ||
  `https://ui-avatars.com/api/?name=${user?.name}&background=random&bold=true`;
